<template>
    <!-- 内存信息 -->
    <div style="width: 100%; height: 100%" id="clockLine"></div>
</template>

<script setup>
import { defineProps, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import * as echarts from 'echarts'

const props = defineProps({
    sourceData: {
        type: Object
    }
})
const options = ref({})
const charts = { chart: null }

const initChart = () => {
    options.value = {
        tooltip: {
            formatter: '{a} <br/>{b} : {c}%'
        },
        series: [
            {
                name: 'Pressure',
                type: 'gauge',
                detail: {
                    formatter: '{value}'
                },
                max: 1000,
                data: [
                    {
                        value: props.sourceData.value || 0,
                        name: '内存消耗'
                    }
                ]
            }
        ]
    }
    charts.chart.setOption(options.value)
    window.addEventListener('resize', () => {
        charts.chart.resize()
    })
}

onMounted(() => {
    charts.chart = echarts.init(document.getElementById('clockLine'))
    initChart()
})
onBeforeUnmount(() => {
    charts.chart.dispose()
})
// initChart()
watch(
    () => props.sourceData,
    (newVal) => {
        initChart()
    },
    { deep: true }
)
watch(
    () => props.yMax,
    (newVal) => {
        initChart()
    }
)
</script>

<style lang="scss" scoped>
#clockLine {
    padding: 0.052083rem /* 10/192 */;
}
</style>
